var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffensive3 = function SvgOffensive3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#204969",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M58 46.538V39.42c0-1.599-1.325-2.91-2.947-2.91h-2.275V31.64C52.778 25.788 47.928 21 42 21s-10.778 4.787-10.778 10.639v4.873h-2.275c-1.62 0-2.947 1.308-2.947 2.91V59.09C26 60.692 27.325 62 28.947 62H55.05c1.62 0 2.948-1.308 2.948-2.91v-9.432l-9.667 6.685.434-5.306h-7.596l11.17-7.03-.473 4.755 6.13-2.225zM35.965 36.512v-4.873c0-3.268 2.727-5.96 6.037-5.96s6.038 2.692 6.038 5.96v4.873z",
    clipRule: "evenodd"
  })));
};
export default SvgOffensive3;